// extracted by mini-css-extract-plugin
export default {"markdown-content":"Markdown_markdown-content__57IIu","anchor":"Markdown_anchor__2KkZr"};